export default __webpack_public_path__ + "static/media/era-banner.e5060810.jpg";